import styled from "styled-components";
import { mediaQueries } from "../../../../styles/mediaQueries";

export const SearchResultsStyled = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: 0;
  width: 130%;
  max-width: 1000px;
  max-height: 600px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 200;
  display: grid;
  grid-template-columns: 250px 1fr;
  overflow: hidden;

  ${mediaQueries("mobile")`
    grid-template-columns: 1fr;
    max-height: 400px;
    width: 100%;
  `}

  .left {
    padding: 20px;
    border-right: 1px solid #f0f0f0;
    background: #fafafa;

    h4 {
      margin: 0 0 16px;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      margin-bottom: 4px;

      button {
        width: 100%;
        text-align: left;
        padding: 12px 16px;
        border: none;
        background: transparent;
        border-radius: 8px;
        font-size: 14px;
        color: #666;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        position: relative;

        &:before {
          content: "🔍";
          margin-right: 8px;
          opacity: 0.5;
        }

        &:after {
          content: "›";
          position: absolute;
          right: 12px;
          font-size: 18px;
          opacity: 0.3;
        }

        &:hover {
          background: #fff;
          color: #333;
          transform: translateX(4px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }
      }
    }
  }

  .right {
    padding: 30px;
    overflow-y: auto;

    h4 {
      margin: 0 0 24px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 16px;
    }

    li {
      display: flex;
      align-items: center;
      padding: 16px;
      border-radius: 12px;
      transition: all 0.2s ease;
      cursor: pointer;
      border: 1px solid #f0f0f0;

      &:hover {
        background: #f8f9fa;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
        border-color: #e0e0e0;
      }

      img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 12px;
        margin-right: 16px;
        background: #f5f5f5;
        border: 1px solid #eee;
        flex-shrink: 0;
      }

      div {
        flex: 1;
        min-width: 0;

        button {
          font-size: 15px;
          color: #333;
          border: none;
          background: none;
          padding: 0;
          text-align: left;
          cursor: pointer;
          transition: color 0.2s;
          margin-bottom: 10px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          width: 100%;
          font-weight: 500;

          &:hover {
            color: var(--primary, #007bff);
          }
        }

        .price-container {
          display: flex;
          align-items: center;
          gap: 10px;

          .current-price {
            font-size: 17px;
            font-weight: 700;
            color: #333;
          }

          .original-price {
            font-size: 15px;
            color: #999;
            text-decoration: line-through;
          }
        }

        span {
          display: block;
          margin-top: 6px;
          font-size: 16px;
          color: #333;
          font-weight: 700;
        }
      }
    }
  }

  .loader {
    grid-column: 1 / -1;
    padding: 20px;
    text-align: center;
    color: #666;
    font-size: 14px;
  }

  .error {
    grid-column: 1 / -1;
    padding: 20px;
    text-align: center;
    color: #e74c3c;
    font-size: 14px;
  }
`;

export const ShowMoreStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px auto 0;
  padding: 16px 32px;
  max-width: 300px;
  width: 100%;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #0056b3;
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(0, 123, 255, 0.3);
  }

  &:after {
    content: "→";
    margin-left: 10px;
    transition: transform 0.2s ease;
  }

  &:hover:after {
    transform: translateX(4px);
  }
`;

export const CategoryList = styled.div``;
export const ProductList = styled.div``;